import { registerFormComponent, registerFormItemComponent } from '@formily/react-schema-renderer';
import { AntdSchemaFormAdaptor } from './Form';
import { AntdSchemaFieldAdaptor } from './FormItem';
registerFormComponent(AntdSchemaFormAdaptor);
registerFormItemComponent(AntdSchemaFieldAdaptor);
export { AntdSchemaFormAdaptor, AntdSchemaFieldAdaptor };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/adaptor/index.js
// module id = 5808
// module chunks = 0